import { PlayIcon } from 'lucide-react';

import ControlButton from './ControlButton';

function StartButton({ onClick }: { onClick: () => void }) {
  return (
    <div>
      <ControlButton variant="default" data-testid="start-button" className="w-full" onClick={onClick} aria-label="Start timer">
        <PlayIcon className="size-6" />
      </ControlButton>
    </div>
  );
}

export default StartButton;
